// extracted by mini-css-extract-plugin
module.exports = {"list":"SpecialtiesTabs_list__2BWzh","item":"SpecialtiesTabs_item__34Mwm","selected":"SpecialtiesTabs_selected__2_H8w"};